import React from "react";
import { CloudDownloadIcon, ErrorCircleIcon, RefreshIcon, XIcon } from "./Icons";

const UpdateConfirmationModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="modal-backdrop show"></div>
      <div
        className="modal show"
        id="DeleteModal"
        aria-modal="true"
        role="dialog"
        onClick={onClose}
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                <RefreshIcon iClass={"me-2"}/>
                Update Available
              </h5>
            </div>

            <div className="modal-body">
              <p className="mb-2">
                A new version of the application is available.
              </p>

              <div className="alert alert-warning mb-0">
                <ErrorCircleIcon iClass={"me-2"}/>
                Unsaved changes will be lost. Please save your work before
                updating.
              </div>
            </div>

            <div className="modal-footer d-flex justify-content-between">
              <button className="btn btn-outline-secondary " onClick={onClose}>
                <XIcon iClass={"font-20"}/> I will
                Do it later
              </button>

              <button className="btn btn-primary" onClick={onConfirm}>
                <CloudDownloadIcon iClass={"font-20"}/>{" "}
                Update Now
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default UpdateConfirmationModal;
